module.exports = __webpack_public_path__ + "static/media/backgroundLoginMobile.7df9af6c.jpg";